import {
  CalendarClock,
  ChartNoAxesCombined,
  Circle,
  LayoutDashboard,
  Megaphone,
  MessagesSquare,
  Package,
  Settings,
  ShieldCheck,
  Ticket,
  Users,
  type LucideIcon,
} from 'lucide-react';

/** Iconos de la navegación, resueltos por nombre desde `lib/navigation`. */
const NAV_ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  Ticket,
  MessagesSquare,
  Users,
  CalendarClock,
  ShieldCheck,
  Package,
  Megaphone,
  ChartNoAxesCombined,
  Settings,
};

export function navIcon(name: string): LucideIcon {
  return NAV_ICONS[name] ?? Circle;
}
